export default window.EventEmmiterModule;